<template>
  <b-modal
    id="delete-order-modal-doorder"
    centered
    modal-class="modal-doorder mt-0"
  >
    <div class="d-block mb-4">
      <p class="confirmMessageModalP message-modal-doorder my-4">
        Are you sure to delete this order?
      </p>
    </div>
    <template class="justify-content-center mt-5" #modal-footer>
      <b-row class="justify-content-center w-100">
        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="doorder-primary"
            class="w-100 btn-bumblebee btn-doorder btn-doorder-submit"
            @click="clickConfirmDelete"
          >
            Yes
          </b-button>
        </b-col>

        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="doorder-danger-outline "
            class="w-100 btn-bumblebee btn-doorder btn-doorder-submit"
            @click="closeModalDelete"
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>


<script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "DeleteOrderModal",
  props: ["order_id"],
  data() {
    return {
      client_name: "DOORDER",

      is_loading: false,
    };
  },
  mounted() {},
  methods: {
    closeModalDelete() {
      this.$bvModal.hide("delete-order-modal-doorder");
    },
    clickConfirmDelete() {
      console.log("submit delete order ", this.order_id);

      this.is_loading = true;

      axios
        .delete("jobs/jobs/" + this.order_id, {
          headers: {
            client: this.client_name,
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: response.data.success,
            type: "success",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
            this.$bvModal.hide("delete-order-modal-doorder");
            this.$router.push({ name: "DoOrderOrdersList" });
          });

          //   this.$parent.getAcceptedRetaailers()
        })
        .catch((error) => {
          console.log(error.response.data.message);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.message,
            type: "error",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/orders/DeleteOrderModel.vue